import React from "react";
import ErrorPage from "./ErrorPage";
import Spinner from "../spinner";

class SuspenseErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Uncaught error:", error);
  }

  resetError = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <ErrorPage resetError={this.resetError} />;
    }

    return <React.Suspense fallback={<Spinner />} {...this.props} />;
  }
}

export default SuspenseErrorBoundary;